var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppPresentations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m15.95 15-.411 1.385L20 20.833s0 .39-.45.778C19.1 22 18.2 22 18.2 22l-5.393-4.66c-.603-.521-3.005-.527-3.604-.01L3.8 22s-.9 0-1.35-.389-.45-.778-.45-.778l4.431-4.419L6.05 15zm4.058-11a1 1 0 0 1 .992.995v8.01a1 1 0 0 1-.992.995H1.992A1 1 0 0 1 1 13.005v-8.01A1 1 0 0 1 1.992 4ZM13.01 0A1 1 0 0 1 14 1h6.998A.995.995 0 0 1 22 2v1H0V2c0-.556.449-1 1.002-1H8c0-.556.444-1 .99-1Z"
})));
export default SvgAppPresentations;